export const CHANGE_INTRO_SLIDES = "CHANGE_INTRO_SLIDES";

export function changeIntroSlides(introSlides) {
  return {
    introSlides,
    type: CHANGE_INTRO_SLIDES
  };
}
